export default class notificationRequest {
  constructor(service) {
    this.service = service;
  }

  getNotificationList$(groupId, from, read) {
    return this.service
      .fetch$({
        method: 'GET',
        url: `/notification/message?groupId=${groupId}&from=${from}&read=${read}&pageSize=999`,
      });
  }

  markNotificationRead$(id) {
    return this.service
      .fetch$({
        method: 'PUT',
        url: '/notification/message/markRead',
        body: [id],
      });
  }
}
